import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	error: {
		id: 'eoc-schedule-common.common.error',
		defaultMessage: 'Error',
		description: 'Just simple error message.',
	},
	tryAgain: {
		id: 'eoc-schedule-common.common.try-again',
		defaultMessage: 'Try again',
		description: 'Try again message when an error occurs.',
	},
	noOne: {
		id: 'eoc-schedule-common.common.no-one',
		defaultMessage: 'No one',
		description: 'Name of the user whose type is no-one.',
	},
	team: {
		id: 'eoc-schedule-common.common.team',
		defaultMessage: 'Team',
		description: 'Label that indicates responder is of type: Team',
	},
	escalation: {
		id: 'eoc-schedule-common.common.escalation',
		defaultMessage: 'Escalation',
		description: 'Label that indicates responder is of type: Escalation',
	},
	schedule: {
		id: 'eoc-schedule-common.common.schedule',
		defaultMessage: 'Schedule',
		description: 'Label that indicates responder is of type: Schedule',
	},
	formerUser: {
		id: 'eoc-schedule-common.common.former-user',
		defaultMessage: 'Former user',
		description: 'Fallback responder name that suggest user is deactivated or deleted.',
	},
	teamDeleted: {
		id: 'eoc-schedule-common.common.team-deleted',
		defaultMessage: 'Team deleted',
		description: 'Fallback responder name that suggest team is deleted.',
	},
	deletedSchedule: {
		id: 'eoc-schedule-common.common.deleted-schedule',
		defaultMessage: 'Deleted schedule',
		description: 'Fallback responder name that suggest schedule is deleted.',
	},
	deletedEscalation: {
		id: 'eoc-schedule-common.common.deleted-escalation',
		defaultMessage: 'Deleted escalation',
		description: 'Fallback responder name that suggest escalation is deleted.',
	},
	missingResponder: {
		id: 'eoc-schedule-common.common.missing-responder',
		defaultMessage: 'Participant missing',
		description: 'Label that indicates there is missing responder.',
	},
	off: {
		id: 'eoc-schedule-common.common.off',
		defaultMessage: 'Off',
		description: 'An indicator for disabled schedule.',
	},
	on: {
		id: 'eoc-schedule-common.common.on',
		defaultMessage: 'On',
		description: 'An indicator for enabled schedule.',
	},
	noStartTime: {
		id: 'eoc-schedule-common.common.no-start-time',
		defaultMessage: 'Earlier than the current period',
		description:
			"Indicates that we are not able to show start time as period item doesn't fit to screen.",
	},
	noEndTime: {
		id: 'eoc-schedule-common.common.no-end-time',
		defaultMessage: 'Later than the current period',
		description:
			"Indicates that we are not able to show end time as period item doesn't fit to screen.",
	},
	from: {
		id: 'eoc-schedule-common.common.from',
		defaultMessage: 'From',
		description: 'Label that "from" side of a range',
	},
	to: {
		id: 'eoc-schedule-common.common.to',
		defaultMessage: 'To',
		description: 'Label that "to" side of a range',
	},
	rotation: {
		id: 'eoc-schedule-common.common.rotation',
		defaultMessage: 'Rotation',
		description: 'Label for rotation field.',
	},
	calendarLayer: {
		id: 'eoc-schedule-common.common.calendar-layer',
		defaultMessage: 'Calendar layer',
		description: 'Label for calendar layer field.',
	},
	timelineLayer: {
		id: 'eoc-schedule-common.common.timeline-layer',
		defaultMessage: 'Timeline layer',
		description: 'Label for timeline layer field.',
	},
	timelineView: {
		id: 'eoc-schedule-common.common.timeline-view',
		defaultMessage: 'Timeline view',
		description: 'Schedule timeline view option label',
	},
	calendarView: {
		id: 'eoc-schedule-common.common.calendar-view',
		defaultMessage: 'Calendar view',
		description: 'Schedule calendar view option label',
	},
	inSchedule: {
		id: 'eoc-schedule-common.common.in-schedule',
		defaultMessage: '{prefix} in schedule {scheduleName}',
		description: 'Label for in schedule.',
	},
	day: {
		id: 'eoc-schedule-common.common.day',
		defaultMessage: 'day',
		description: 'Label for day period.',
	},
	week: {
		id: 'eoc-schedule-common.common.week',
		defaultMessage: 'week',
		description: 'Label for week period.',
	},
	month: {
		id: 'eoc-schedule-common.common.month',
		defaultMessage: 'month',
		description: 'Label for month period.',
	},
	oneDay: {
		id: 'eoc-schedule-common.common.one-day',
		defaultMessage: '1 day',
		description: 'Label for seeing periods in the range of 1 day.',
	},
	oneWeek: {
		id: 'eoc-schedule-common.common.one-week',
		defaultMessage: '1 week',
		description: ' Label for seeing periods in the range of 1 week.',
	},
	twoWeeks: {
		id: 'eoc-schedule-common.common.two-weeks',
		defaultMessage: '2 weeks',
		description: ' Label for seeing periods in the range of 2 weeks.',
	},
	oneMonth: {
		id: 'eoc-schedule-common.common.one-month',
		defaultMessage: '1 month',
		description: ' Label for seeing periods in the range of 1 month.',
	},
	yourShifts: {
		id: 'eoc-schedule-common.common.your-shifts',
		defaultMessage: 'Your shifts',
		description: 'Label for your shifts.',
	},
	selectTimelineView: {
		id: 'eoc-schedule-common.common.select-timeline-view',
		defaultMessage: 'Select the timeline period for schedule {scheduleName}',
		description: 'Label for selecting timeline view.',
	},
	selectScheduleView: {
		id: 'eoc-schedule-common.common.select-schedule-view',
		defaultMessage: 'Select schedule view type for schedule {scheduleName}',
		description: 'Label for selecting schedule view.',
	},
	quickOverrideTitle: {
		id: 'eoc-schedule-common.common.quick-override-title',
		defaultMessage: 'Override',
		description: 'Title for quick override card.',
	},
	selectionCount: {
		id: 'eoc-schedule-common.common.selection-count',
		defaultMessage: '{count} shifts selected',
		description: 'Indicates how many shifts are selected for override.',
	},
	confirmProceed: {
		id: 'eoc-schedule-common.common.confirm-proceed',
		defaultMessage: 'Are you sure to proceed?',
		description: 'A confirmation for proceeding.',
	},
	base: {
		id: 'eoc-schedule-common.common.base',
		defaultMessage: 'Base',
		description: 'Base layer view of a schedule',
	},
	forwarding: {
		id: 'eoc-schedule-common.common.forwarding',
		defaultMessage: 'Forwarding',
		description: 'Forwarding layer view of a schedule',
	},
	final: {
		id: 'eoc-schedule-common.common.final',
		defaultMessage: 'Final',
		description: 'Final layer view of a schedule',
	},
	search: {
		id: 'eoc-schedule-common.common.search',
		defaultMessage: 'Search',
		description: 'Label of search icon that shown inside search participant field',
	},
	participants: {
		id: 'eoc-schedule-common.common.participants',
		defaultMessage: 'Participants',
		description: 'Label for participants.',
	},
	addParticipants: {
		id: 'eoc-schedule-common.common.add-participants',
		defaultMessage: 'Add people, teams, and escalation policies',
		description: 'Placeholder text for auto complete field for participants (responders).',
	},
	select: {
		id: 'eoc-schedule-common.common.select',
		defaultMessage: 'Select',
		description: 'Label that indicates selecting.',
	},
	noneGlobalSchedule: {
		id: 'eoc-schedule-common.common.none-global-schedule',
		defaultMessage: 'None (Global schedule)',
		description: 'Label for global schedule that is not owned by any team.',
	},
	noneGlobalScheduleBold: {
		id: 'eoc-schedule-common.common.none-global-schedule-bold',
		defaultMessage: '<bold>None</bold> (Global schedule)',
		description: 'Label for global schedule that is not owned by any team.',
	},

	/*
   Common button related messages
  */

	nextPeriod: {
		id: 'eoc-schedule-common.common.next-period',
		defaultMessage: 'Next {period}',
		description: 'Button for going to next period. Ex. Next 2 weeks',
	},
	previousPeriod: {
		id: 'eoc-schedule-common.common.previous-period',
		defaultMessage: 'Previous {period}',
		description: 'Button for going to previous period. Ex. Previous month',
	},
	showAllLayers: {
		id: 'eoc-schedule-common.common.show-all-layers',
		defaultMessage: 'Show all layers',
		description: 'Button for showing all layers of schedule.',
	},
	showLessLayers: {
		id: 'eoc-schedule-common.common.show-less-layers',
		defaultMessage: 'Show less layers',
		description: 'Button for showing less layers of schedule.',
	},
	cancel: {
		id: 'eoc-schedule-common.common.cancel',
		defaultMessage: 'Cancel',
		description: 'Button for cancelling an action.',
	},
	close: {
		id: 'eoc-schedule-common.common.close',
		defaultMessage: 'Close',
		description: 'Button for closing modal or dialog.',
	},
	today: {
		id: 'eoc-schedule-common.common.today',
		defaultMessage: 'Today',
		description: 'Buttom for navigating to today.',
	},
	override: {
		id: 'eoc-schedule-common.common.override',
		defaultMessage: 'Override',
		description: 'Button for adding override.',
	},
	save: {
		id: 'eoc-schedule-common.common.save',
		defaultMessage: 'Save',
		description: 'Buttom for saving changes.',
	},
	confirm: {
		id: 'eoc-schedule-common.common.confirm',
		defaultMessage: 'Confirm',
		description: 'A confirm button.',
	},
	discard: {
		id: 'eoc-schedule-common.common.discard',
		defaultMessage: 'Discard',
		description: 'Button for discarding.',
	},
	moreActionsForSchedule: {
		id: 'eoc-schedule-common.common.more-actions-for-schedule',
		defaultMessage: 'More actions for schedule {scheduleName}',
		description: 'Button for schedule settings.',
	},
	loadMore: {
		id: 'eoc-schedule-common.common.loadMore',
		defaultMessage: 'Load more',
		description: 'Button for loading more schedules.',
	},
	replaceWith: {
		id: 'eoc-schedule-common.common.replace-with',
		defaultMessage: 'Replace with',
		description: 'Button for opening popup for replacing a participant.',
	},
	remove: {
		id: 'eoc-schedule-common.common.remove',
		defaultMessage: 'Remove',
		description: 'Button for removing schedule or rotation.',
	},
	delete: {
		id: 'eoc-schedule-common.common.delete',
		defaultMessage: 'Delete',
		description: 'Button for deleting schedule or rotation.',
	},
	edit: {
		id: 'eoc-schedule-common.common.edit',
		defaultMessage: 'Edit',
		description: 'Button for editing schedule or rotation.',
	},
	duplicate: {
		id: 'eoc-schedule-common.common.duplicate',
		defaultMessage: 'Duplicate',
		description: 'Button for duplicating schedule or rotation.',
	},

	/*
   Common start and end related messages
  */

	start: {
		id: 'eoc-schedule.common.start',
		defaultMessage: 'Start',
		description: 'Label for start time and date.',
	},
	end: {
		id: 'eoc-schedule.common.end',
		defaultMessage: 'End',
		description: 'Label for end time and date.',
	},
	startTime: {
		id: 'eoc-schedule.common.start-time',
		defaultMessage: 'Start time',
		description: 'Label for start time and date.',
	},
	endTime: {
		id: 'eoc-schedule.common.end-time',
		defaultMessage: 'End time',
		description: 'Label for end time and date.',
	},
	startDate: {
		id: 'eoc-schedule.common.start-date',
		defaultMessage: 'Start date',
		description: 'Label for start time and date.',
	},
	endDate: {
		id: 'eoc-schedule.common.end-date',
		defaultMessage: 'End date',
		description: 'Label for end time and date.',
	},

	/*
   Common validation related messages
  */

	required: {
		id: 'eoc-schedule-common.common.required',
		defaultMessage: 'This field is required.',
		description: 'A text that informs users that field should be filled.',
	},
	noSpaceAtEndOrStart: {
		id: 'eoc-schedule-common.common.no-space-at-end-or-start',
		defaultMessage: 'Field cannot contain spaces at start or end.',
		description: 'A text that informs users that field cannot start or end with spaces.',
	},
	maxLength: {
		id: 'eoc-schedule-common.common.max-length',
		defaultMessage: 'Field cannot be longer than {max} characters.',
		description: 'A text that informs users that field should be shorter than certain length.',
	},
	maxValue: {
		id: 'eoc-schedule-common.common.max-value',
		defaultMessage: 'Field should be less than {max}.',
		description: 'A text that informs users that field should be less than certain value.',
	},
	minValue: {
		id: 'eoc-schedule-common.common.min-value',
		defaultMessage: 'Enter digit 1 or more.',
		description:
			'This sentence instructs the user to input a numeric value of at least 1 digit or greater.',
	},
	timePast: {
		id: 'eoc-schedule-common.common.time-past',
		defaultMessage: 'Time should be later than current time.',
		description: 'Validation error that indicates time values is in past.',
	},
	startLaterEnd: {
		id: 'eoc-schedule-common.common.start-later-end',
		defaultMessage: 'Start time should be earlier than the end time.',
		description: 'Validation error that indicates start time is later than the end time.',
	},
	endEarlierStart: {
		id: 'eoc-schedule-common.common.end-earlier-start',
		defaultMessage: 'End time should be later than the start time.',
		description: 'Validation error that indicates end time is earlier than the start time.',
	},
	startEndSame: {
		id: 'eoc-schedule-common.common.start-end-same',
		defaultMessage: 'Start and end time cannot be same.',
		description: 'Validation error that indicates start and end time should be different.',
	},
	thirtyMinuteInterval: {
		id: 'eoc-schedule-common.common.thirty-minute-intervals',
		defaultMessage: 'Time should be defined as 30 minute intervals.',
		description: 'Validation error that indicates time can be in 30 minutes intervals.',
	},

	/*
	 Common feedback related messages
	*/
	exportTimelineErrorTitle: {
		id: 'eoc-schedule-common.common.export-timeline-error-title',
		defaultMessage: "We couldn't export your schedule.",
		description:
			'This message indicates that our back-end services did not respond when exporting schedule.',
	},
	exportTimelineSuccessTitle: {
		id: 'eoc-schedule-common.common.export-timeline-success-title',
		defaultMessage: 'Your schedule is successfully exported.',
		description: 'This message indicates schedule is successfully exported.',
	},
	updateScheduleErrorTitle: {
		id: 'eoc-schedule-common.common.update-schedule-error-title',
		defaultMessage: "We couldn't update your schedule.",
		description:
			'This message indicates that our back-end services did not respond when updating schedule.',
	},
	deleteScheduleSuccessTitle: {
		id: 'eoc-schedule-common.common.delete-schedule-success-title',
		defaultMessage: 'Your schedule is successfully deleted.',
		description: 'This message indicates schedule is successfully deleted.',
	},
	deleteScheduleErrorTitle: {
		id: 'eoc-schedule-common.common.delete-schedule-error-title',
		defaultMessage: "We couldn't delete your schedule.",
		description:
			'This message indicates that our back-end services did not respond when deleting schedule.',
	},
	createScheduleErrorTitle: {
		id: 'eoc-schedule-common.common.create-schedule-error-title',
		defaultMessage: "We couldn't create your schedule.",
		description:
			'This message indicates that our back-end services did not respond when creating schedule.',
	},
	createScheduleSuccessTitle: {
		id: 'eoc-schedule-common.common.create-schedule-success-title',
		defaultMessage: 'You’ve created a new schedule',
		description: 'This message indicates schedule is successfully created.',
	},
	createScheduleSuccessDescription: {
		id: 'eoc-schedule-common.common.create-schedule-success-description',
		defaultMessage:
			'Continue to configure this schedule by adding participants and rotation details.',
		description: 'This message indicates schedule is successfully created.',
	},
	cloneScheduleErrorTitle: {
		id: 'eoc-schedule-common.common.clone-schedule-error-title',
		defaultMessage: "We couldn't duplicate your schedule.",
		description:
			'This message indicates that our back-end services did not respond when duplicating schedule.',
	},
	cloneScheduleSuccessTitle: {
		id: 'eoc-schedule-common.common.clone-schedule-success-title',
		defaultMessage: "You've duplicated the schedule.",
		description: 'This message indicates schedule is successfully duplicated.',
	},

	/*
	 Common dropdown actions related messages
	*/
	export: {
		id: 'eoc-schedule-common.common.export',
		defaultMessage: 'Export',
		description: 'Export schedule option in the dropdown',
	},
	turnOn: {
		id: 'eoc-schedule-common.common.turn-on',
		defaultMessage: 'Turn on',
		description: 'Turn on schedule option in the dropdown',
	},
	turnOff: {
		id: 'eoc-schedule-common.common.turn-off',
		defaultMessage: 'Turn off',
		description: 'Turn off schedule option in the dropdown',
	},

	/*
	 Create & duplicate schedule related messages
	*/
	createSchedule: {
		id: 'eoc-schedule-common.common.create-schedule',
		defaultMessage: 'Create schedule',
		description: 'Create a new schedule title.',
	},
	scheduleName: {
		id: 'eoc-schedule-common.common.schedule-name',
		defaultMessage: 'Schedule name',
		description: 'Text field label for schedule name.',
	},
	description: {
		id: 'eoc-schedule-common.common.description',
		defaultMessage: 'Description',
		description: 'Text field label for schedule description.',
	},
	timezone: {
		id: 'eoc-schedule-common.common.timezone',
		defaultMessage: 'Timezone',
		description: 'Text field label for schedule timezone.',
	},
	create: {
		id: 'eoc-schedule-common.common.create',
		defaultMessage: 'Create',
		description: 'A create button for create schedule.',
	},
	copyOfScheduleName: {
		id: 'eoc-schedule-common.common.copy-of-schedule-name',
		defaultMessage: 'Copy of {scheduleName}',
		description: 'Automatically generated cloned schedule name. Ex. Copy of Paid Schedule',
	},
	createScheduleFooter: {
		id: 'eoc-schedule-common.common.create-schedule-footer',
		defaultMessage: 'Save this schedule to add rotations and configure its details.',
		description: 'Footer text for create schedule.',
	},
});
